var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2056 18.0043C33.9293 14.2814 33.9293 8.24544 30.2056 4.52258C26.4819 0.799723 20.4446 0.799723 16.721 4.52258L6 15.2412V28.7388H19.5005L30.2056 18.0043Z",
    stroke: "#171616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 14.6447,
    x2: 1.91421,
    y2: 34.2305,
    stroke: "#171616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 22.2402,
    x2: 15.5,
    y2: 22.2402,
    stroke: "#171616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeather);
export default __webpack_public_path__ + "static/media/feather.a78b45282da9a3724fe5b733e895e0cd.svg";
export { ForwardRef as ReactComponent };